import React from 'react'
import img1 from '../../assets/images/yogesh logo.png';
import { Link } from 'react-router-dom';

import { GrLocation } from "react-icons/gr";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <>
    <footer className="bg-gray-900  ">
        <div className="relative z-10 pt-20 lg:pt-[100px] ">
          <div className="container mx-auto ">
            <div className=" flex flex-wrap">
              <div className="w-full px-4 md:w-1/2 lg:w-5/12 xl:w-4/12 ">
                <div className="mb-16 max-w-[310px]">
                  <a href="/" className="mb-4 inline-block">
                    <img src={img1} alt="logo" className="w-36 md:max-w-48" />
                  </a>
                  <p className="mb-5 flex items-center text-2xl font-semibold text-white">
                    <span className="pr-3">
                      <GrLocation />
                    </span>
                    Our Store Locations
                  </p>

                  <p className=" flex text-base text-[#cacbcf] leading-relaxed tracking-wider">
                    
                    14C, Bye Pass Road, East Sengulam, Thirumangalam, Madurai - 625 706.
                  </p>
                 
                </div>
              </div>

              <div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-3/12 xl:w-2/12 ">
                <div className="mb-16">
                  <h3 className="pb-5 text-xl font-semibold text-white">
                    Important Links
                  </h3>
                  <span className="mb-8 block h-[3px] w-10 rounded bg-white"></span>

                  <ul className="space-y-3">
                  <li>
                      
                      <Link to={'/'} className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624] ">Home Page</Link>
                    </li>
                    <li>
                      
                      <Link to={'/about'} className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624] ">About us</Link>
                    </li>
                    <li>
                      
                      <Link to={'/product'} className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624] ">Our Products</Link>
                    </li>
                    <li>
                      
                      <Link to={'/safety'} className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624] ">Safety and Security</Link>
                    </li>
                    <li>
                      
                      <Link to={'/contact'} className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624] ">Contact Us</Link>
                    </li>
                    
                  </ul>
                </div>
              </div>

              <div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-2/12 ">
                <div className="mb-16">
                  <h3 className="pb-5 text-xl font-semibold text-white">
                    Top Categories
                  </h3>
                  <span className="mb-8 block h-[3px] w-10 rounded bg-white"></span>

                  <ul className="space-y-3">
                    <li>
                      <a href="javascript:void(0)" className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624]">
                      Step Ladder
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624]">
                      Trolley Step Ladder
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624]">
                      Self & Wall Supporting Extendable Ladder
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624]">
                      Green & Blue Fancy Arch Ladder
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" className="text-base text-[#cacbcf] transition-all hover:text-[#F2C624]">
                      Tiltable & Erect Tower Extension Ladder
                      </a>
                    </li>
                    
                  </ul>
                </div>
              </div>

              <div className="w-full px-4 md:w-1/2 lg:w-5/12 xl:w-4/12 ">
                <div className="mb-16">
                  <h3 className="pb-5 text-xl font-semibold text-white">Newsletter</h3>
                  <span className="mb-8 block h-[3px] w-10 rounded bg-white"></span>

                  <div>
                    <p className="mb-8 text-base text-[#cacbcf]">
                      Enter your email to receive our latest updates about our
                      products.
                    </p>
                    <form className="relative">
                      <input type="email" placeholder="Email address" className="h-[50px] w-full bg-[#1f2735] pl-5 pr-[125px] text-[#CACBCF] rounded-md outline-none placeholder:text-[#CACBCF]" />
                        <button className="absolute right-2 top-1/2 -translate-y-1/2 rounded px-3 md:px-5 py-1.5 md:py-2 text-sm font-medium text-white bg-blue-950 hover:bg-blue-900">
                          Subscribe
                        </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <span className="absolute bottom-0 left-0 -z-10">
              <svg width="138" height="220" viewBox="0 0 138 220" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="-2.5" cy="140.5" rx="140.5" ry="140.5" transform="rotate(180 -2.5 140.5)" fill="url(#paint0_linear_2089_516)"></ellipse>
                <defs>
                  <linearGradient id="paint0_linear_2089_516" x1="-2.5" y1="-1.52588e-05" x2="-2.5" y2="281" gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" stop-opacity="0.22"></stop>
                    <stop offset="1" stop-color="white" stop-opacity="0"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </span>

            <span className="absolute right-5 top-5 -z-10">
              <svg width="53" height="69" viewBox="0 0 53 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.88244 32.7854C2.92209 32.7854 3.76488 33.6194 3.76488 34.6483C3.76488 35.6771 2.92209 36.5111 1.88244 36.5111C0.84279 36.5111 4.54444e-08 35.6771 0 34.6483C-4.54444e-08 33.6194 0.84279 32.7854 1.88244 32.7854Z" fill="white" fill-opacity="0.3"></path>
                <path d="M1.88244 16.3932C2.92209 16.3932 3.76488 17.2272 3.76488 18.256C3.76488 19.2849 2.92209 20.1189 1.88244 20.1189C0.84279 20.1189 4.54444e-08 19.2849 0 18.256C-4.54444e-08 17.2272 0.84279 16.3932 1.88244 16.3932Z" fill="white" fill-opacity="0.3"></path>
                <path d="M1.88244 0.000350049C2.92209 0.000350004 3.76488 0.834362 3.76488 1.86317C3.76488 2.89199 2.92209 3.726 1.88244 3.726C0.84279 3.726 4.54444e-08 2.89199 0 1.86317C-4.54444e-08 0.834362 0.84279 0.000350094 1.88244 0.000350049Z" fill="white" fill-opacity="0.3"></path>
                <path d="M17.9867 32.7861C19.0263 32.7861 19.8691 33.6201 19.8691 34.6489C19.8691 35.6777 19.0263 36.5118 17.9867 36.5118C16.947 36.5118 16.1042 35.6777 16.1042 34.6489C16.1042 33.6201 16.947 32.7861 17.9867 32.7861Z" fill="white" fill-opacity="0.3"></path>
                <path d="M34.5522 32.7861C35.5918 32.7861 36.4346 33.6201 36.4346 34.6489C36.4346 35.6777 35.5918 36.5118 34.5522 36.5118C33.5125 36.5118 32.6698 35.6777 32.6698 34.6489C32.6698 33.6201 33.5125 32.7861 34.5522 32.7861Z" fill="white" fill-opacity="0.3"></path>
                <path d="M51.1176 32.7861C52.1572 32.7861 53 33.6201 53 34.6489C53 35.6777 52.1572 36.5118 51.1176 36.5118C50.0779 36.5118 49.2351 35.6777 49.2351 34.6489C49.2351 33.6201 50.0779 32.7861 51.1176 32.7861Z" fill="white" fill-opacity="0.3"></path>
                <path d="M17.9867 16.3932C19.0263 16.3932 19.8691 17.2272 19.8691 18.256C19.8691 19.2849 19.0263 20.1189 17.9867 20.1189C16.947 20.1189 16.1042 19.2849 16.1042 18.256C16.1042 17.2272 16.947 16.3932 17.9867 16.3932Z" fill="white" fill-opacity="0.3"></path>
                <path d="M34.5522 16.3932C35.5918 16.3932 36.4346 17.2272 36.4346 18.256C36.4346 19.2849 35.5918 20.1189 34.5522 20.1189C33.5125 20.1189 32.6698 19.2849 32.6698 18.256C32.6698 17.2272 33.5125 16.3932 34.5522 16.3932Z" fill="white" fill-opacity="0.3"></path>
                <path d="M51.1176 16.3932C52.1572 16.3932 53 17.2272 53 18.256C53 19.2849 52.1572 20.1189 51.1176 20.1189C50.0779 20.1189 49.2351 19.2849 49.2351 18.256C49.2351 17.2272 50.0779 16.3932 51.1176 16.3932Z" fill="white" fill-opacity="0.3"></path>
                <path d="M17.9867 1.52195e-05C19.0263 1.51746e-05 19.8691 0.834042 19.8691 1.86285C19.8691 2.89167 19.0263 3.72568 17.9867 3.72568C16.947 3.72568 16.1042 2.89167 16.1042 1.86285C16.1042 0.834042 16.947 1.52645e-05 17.9867 1.52195e-05Z" fill="white" fill-opacity="0.3"></path>
                <path d="M34.5522 0C35.5918 -4.49708e-08 36.4346 0.834042 36.4346 1.86285C36.4346 2.89167 35.5918 3.72568 34.5522 3.72568C33.5125 3.72568 32.6698 2.89167 32.6698 1.86285C32.6698 0.834042 33.5125 4.49708e-08 34.5522 0Z" fill="white" fill-opacity="0.3"></path>
                <path d="M51.1176 0C52.1572 -4.49708e-08 53 0.834042 53 1.86285C53 2.89167 52.1572 3.72568 51.1176 3.72568C50.0779 3.72568 49.2351 2.89167 49.2351 1.86285C49.2351 0.834042 50.0779 4.49708e-08 51.1176 0Z" fill="white" fill-opacity="0.3"></path>
                <path d="M1.88244 65.274C2.92209 65.274 3.76488 66.108 3.76488 67.1369C3.76488 68.1657 2.92209 68.9997 1.88244 68.9997C0.84279 68.9997 4.54444e-08 68.1657 0 67.1369C-4.54444e-08 66.108 0.84279 65.274 1.88244 65.274Z" fill="white" fill-opacity="0.3"></path>
                <path d="M1.88244 48.8815C2.92209 48.8815 3.76488 49.7155 3.76488 50.7443C3.76488 51.7731 2.92209 52.6071 1.88244 52.6071C0.84279 52.6071 4.54444e-08 51.7731 0 50.7443C-4.54444e-08 49.7155 0.84279 48.8815 1.88244 48.8815Z" fill="white" fill-opacity="0.3"></path>
                <path d="M17.9867 65.274C19.0263 65.274 19.8691 66.108 19.8691 67.1369C19.8691 68.1657 19.0263 68.9997 17.9867 68.9997C16.947 68.9997 16.1042 68.1657 16.1042 67.1369C16.1042 66.108 16.947 65.274 17.9867 65.274Z" fill="white" fill-opacity="0.3"></path>
                <path d="M34.5522 65.2744C35.5918 65.2744 36.4346 66.1084 36.4346 67.1372C36.4346 68.166 35.5918 69 34.5522 69C33.5125 69 32.6698 68.166 32.6698 67.1372C32.6698 66.1084 33.5125 65.2744 34.5522 65.2744Z" fill="white" fill-opacity="0.3"></path>
                <path d="M51.1176 65.2744C52.1572 65.2744 53 66.1084 53 67.1372C53 68.166 52.1572 69 51.1176 69C50.0779 69 49.2351 68.166 49.2351 67.1372C49.2351 66.1084 50.0779 65.2744 51.1176 65.2744Z" fill="white" fill-opacity="0.3"></path>
                <path d="M17.9867 48.8811C19.0263 48.8811 19.8691 49.7151 19.8691 50.744C19.8691 51.7728 19.0263 52.6068 17.9867 52.6068C16.947 52.6068 16.1042 51.7728 16.1042 50.744C16.1042 49.7151 16.947 48.8811 17.9867 48.8811Z" fill="white" fill-opacity="0.3"></path>
                <path d="M34.5522 48.8811C35.5918 48.8811 36.4346 49.7151 36.4346 50.744C36.4346 51.7728 35.5918 52.6068 34.5522 52.6068C33.5125 52.6068 32.6698 51.7728 32.6698 50.744C32.6698 49.7151 33.5125 48.8811 34.5522 48.8811Z" fill="white" fill-opacity="0.3"></path>
                <path d="M51.1176 48.8811C52.1572 48.8811 53 49.7151 53 50.744C53 51.7728 52.1572 52.6068 51.1176 52.6068C50.0779 52.6068 49.2351 51.7728 49.2351 50.744C49.2351 49.7151 50.0779 48.8811 51.1176 48.8811Z" fill="white" fill-opacity="0.3"></path>
              </svg>
            </span>

            <span className="absolute right-0 top-0 -z-10">
              <svg width="98" height="94" viewBox="0 0 98 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="98.5" cy="-4.5" rx="98.5" ry="98.5" transform="rotate(90 98.5 -4.5)" fill="url(#paint0_linear_2089_517)"></ellipse>
                <defs>
                  <linearGradient id="paint0_linear_2089_517" x1="98.5" y1="-103" x2="98.5" y2="94" gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" stop-opacity="0.22"></stop>
                    <stop offset="1" stop-color="white" stop-opacity="0"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </span>
          </div>
        </div>
        <div className="bg-[#2E3842] py-7">
          <div className="container mx-auto">
            <div className=" md:flex space-y-2 md:space-y-0 items-center justify-between">
              <div className=" w-full px-4 ">
                <p className=" text-base font-medium text-[#CACBCF] lg:text-left">
                  <span className='text-lg'>©</span> 2024 Virtual Technology. All Rights Reserved.
                </p>
              </div>

              

              <div className="w-full px-4">
                <div className=" flex items-center  space-x-[14px] md:justify-end ">
                  <span className="text-base font-medium text-white"> Follow Us: </span>

                  <a href="/" className="text-white/50 hover:text-white text-lg">
                    <FaFacebookF />
                  </a>

                  <a href="/" className="text-white/50 hover:text-white text-lg">
                  <FaWhatsapp />
                  </a>

                  <a href="/" className="text-white/50 hover:text-white text-lg">
                  <FaInstagram />
                  </a>

                  <a href="/" className="text-white/50 hover:text-white text-lg">
                  <FaLinkedinIn />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer